import {
  ActivityTypeName,
  AccountSubType,
  AccountType,
} from "@syla/shared/types/models/AccountBase";
import { ActivityTypeDescription } from "../../../pages/accountSettings/AccountSubtypeSelector";
import { StandardSelectOption } from "../../selector/parts/SelectOption";

export const ACCOUNT_TYPE_OPTIONS: StandardSelectOption<AccountType>[] = [
  {
    value: AccountType.Individual,
    data: {
      label: "Individual",
    },
  },
  {
    value: AccountType.Trust,
    data: {
      label: "Trust",
    },
  },
  {
    value: AccountType.Company,
    data: {
      label: "Company",
    },
  },
  {
    value: AccountType.SMSF,
    data: {
      label: "Self-Managed Super Fund (SMSF)",
    },
  },
];

export const ACTIVITY_TYPE_OPTIONS: StandardSelectOption<AccountSubType>[] = [
  {
    value: AccountSubType.Investor,
    data: {
      label: ActivityTypeName[AccountSubType.Investor],
      description: ActivityTypeDescription[AccountSubType.Investor],
    },
  },
  {
    value: AccountSubType.Trader,
    data: {
      label: ActivityTypeName[AccountSubType.Trader],
      description: ActivityTypeDescription[AccountSubType.Trader],
    },
  },
];
